export interface IAccountItem {
  name: string;
}

export default function AccountItem(props: IAccountItem) {
  return (
    <div className="inline-flex items-center gap-6 h-[74px] p-5 w-full">
      <div className="bg-woman_avatar bg-contain bg-no-repeat bg-center w-20 h-20" />
      <div className="text-large w-full">{props.name}</div>
    </div>
  );
}
